// extracted by mini-css-extract-plugin
export default {"h1":"styles_h1__N6MAW","statsTable":"styles_statsTable__zbVY3","chart":"styles_chart__g+Y9f"};